import React from 'react'
import gql from 'graphql-tag'
import { RouteComponentProps } from 'react-router-dom'
import { useGlobalContext } from '@/components/context'
import { useMetabaseModuleDashboardEmbedUrlQuery } from './__gen'
import { MetabaseIframe } from './iframe'
import Placeholder from '@/components/common/placeholder'
import style from './index.module.sass'

gql`
	query metabaseModuleDashboardEmbedUrl($id: ID!, $teamId: String) {
		metabaseModuleDashboard(id: $id) {
			id
			name
			embedUrl(teamId: $teamId)
		}
	}
`

type Props = RouteComponentProps<{ id: string }>
export const MetabaseDashboard = (props: Props) => {
	const globalContext = useGlobalContext()
	const { data, loading } = useMetabaseModuleDashboardEmbedUrlQuery({
		variables: {
			id: props.match.params.id,
			teamId: globalContext.currentTeam ? globalContext.currentTeam.id : null,
		},
	})
	if (loading) {
		return <div className={style.loadingContainer}>
			<Placeholder className={style.card} />
			<Placeholder className={style.card} />
			<Placeholder className={style.card} />
			<Placeholder className={style.card} />
		</div>
	} else if (!data?.metabaseModuleDashboard) {
		return <div>Dashboard not found in module</div>
	}
	return <MetabaseIframe dashboard={data.metabaseModuleDashboard} />
}
